import { render, staticRenderFns } from "./AdminRoleAddNew.vue?vue&type=template&id=097b4d73&scoped=true"
import script from "./AdminRoleAddNew.vue?vue&type=script&lang=js"
export * from "./AdminRoleAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b4d73",
  null
  
)

export default component.exports